import { cellStyle } from "../../../components/Table/Table.styles";
import { roundToTwo } from "../../../services/utils/roundToTwo";

// define your filters
export const defaultDropDownFilters = {
  status: {
    id: 0,
    title: "Status",
    options: [],
    enum: true,
    enumOptions: ["Inactive", "Active"],
  },
};

// define your columns
export const getColumns = () => {
  return [
    {
      title: "Status",
      field: "status",
      searchable: false,
      cellStyle: cellStyle,
      render: (company: any) => {
        return <>{company.status === 1 ? "Active" : "Inactive"}</>;
      },
      customFilterAndSearch: (value: any, rowData: any) => {
        if (value[value.length - 1] === "any") {
          return rowData;
        } else {
          return value.indexOf(rowData.status) > -1;
        }
      },
    },
    {
      title: "Company Name",
      field: "name",
      align: "left",
      cellStyle: cellStyle,
    },
    {
      title: "Address",
      field: "address",
      cellStyle: cellStyle,
      searchable: false,
      customFilterAndSearch: null,
    },
    {
      title: "Number of Team Members",
      field: "numberOfEmployees",
      type: "numeric",
      align: "left",
      cellStyle: cellStyle,
      customFilterAndSearch: null,
      render: (company: any) => {
        return roundToTwo(
          parseFloat(company.numberOfEmployees as unknown as string)
        );
      },
    },
    {
      title: "Number of Offices",
      field: "numberOfOffices",
      type: "numeric",
      align: "left",
      cellStyle: cellStyle,
      customFilterAndSearch: null,
      render: (company: any) => {
        return roundToTwo(
          parseFloat(company.numberOfOffices as unknown as string)
        );
      },
    },
  ];
};
